export class AppService {
    constructor(languageService) {
        this._languageService = languageService;
    }

    getInitialAppSettings() {
        const sourceLanguage = this._languageService.SupportedLanguages.find(x => x.default);
        const sourceDialect = sourceLanguage.dialects.find(x => x.default);
        const sourceLocale = this._languageService.getLocale(sourceLanguage, sourceDialect);

        return {
            sourceLanguage,
            sourceDialect,
            sourceLocale,
            targetLanguage: null,
            targetDialect: null,
            targetLocale: null,
            conversationId: null,
        };
    }
}
